import { memo, type ComponentType, type NamedExoticComponent } from 'react'

/**
 * Creates a memoized cell component with proper displayName.
 * Reduces boilerplate in cell components.
 *
 * @example
 * // Before
 * const MemoizedCellText = memo(CellText)
 * MemoizedCellText.displayName = 'CellText'
 * export { MemoizedCellText as CellText }
 *
 * // After
 * export const CellText = createMemoCell(CellTextBase, 'CellText')
 */
export function createMemoCell<P extends object>(
  Component: ComponentType<P>,
  displayName: string
): NamedExoticComponent<P> {
  const MemoizedComponent = memo(Component)
  MemoizedComponent.displayName = displayName
  return MemoizedComponent
}
